/**
 *
 * ResumeOverlay
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  wrapper: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    zIndex: 800,
  },
  container: {
    width: 568,
    maxWidth: '80%',
    position: 'absolute',
    left: '50%',
    top: 120,
    transform: 'translateX(-50%)',
    backgroundColor: '#FFFFFF',
  },
  content: {
    padding: '55px 50px 45px',
    position: 'relative',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      padding: '40px 30px 25px',
    },
  },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 36,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  button: {
    ...theme.typography.button,
    textTransform: 'uppercase',
    marginLeft: 4,
    marginRight: 4,
    height: 43,
    width: 181,
    borderRadius: 2,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      marginLeft: 0,
      marginRight: 0,
      marginTop: 8,
      '&:first-child': {
        marginTop: 0,
      },
    },
  },
}));

const ResumeOverlay = ({ onClick, visible }) => {
  const classes = useStyles();
  const [siteCopy] = useSiteCopySelector(['assessment']);

  if (!visible) return null;

  const handleResume = () => onClick(true);
  const handleStartOver = () => onClick(false);

  return (
    <Box component="div" className={classes.wrapper}>
      <Box
        component="div"
        className={classes.container}
        id="resume-overlay-container"
      >
        <Box component="div" className={classes.content}>
          <Typography variant="h4" color="textPrimary" align="center">
            {_get(siteCopy, 'pageCopy.resumeModalHeader', '')}
          </Typography>
          <Box component="div" className={classes.buttonsWrapper}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleResume}
              className={classes.button}
            >
              {_get(siteCopy, 'pageCopy.resumeModalConfirmLabel', '')}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleStartOver}
              className={classes.button}
            >
              {_get(siteCopy, 'pageCopy.resumeModalRefuseLabel', '')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

ResumeOverlay.propTypes = {
  onClick: PropTypes.func,
  visible: PropTypes.bool,
};

export default ResumeOverlay;
